<template>
  <div class="tax-card">
    <v-flex xs12>
      {{this.translateToFeeName(this.tax_name)}}
      <v-btn v-if="mode == 'read'" @click="mode = 'insert'">Nova regra</v-btn>
      <v-btn v-if="mode != 'read'" color="error" @click="clearFields">Cancelar</v-btn>
      <Container
        orientation="vertical"
        v-if="tax_ruleset.length > 0"
        @drop="onDrop"
      >
        <Draggable v-for="(param, index) in tax_ruleset" :key="index">
          <v-chip
            close
            size="large"
            @click="editRule(param, index)"
            @input="tax_ruleset.splice(index, 1)"
          >
            <span v-if="param.fixed_value">Fixa: {{param.fixed_value}}&nbsp;</span>
            <span v-if="param.percentage_value">Percentual: {{param.percentage_value}}&nbsp;</span>
            <span v-if="param.greater_than">Acima de {{Number(param.greater_than).toFixed(2)}}&nbsp;</span>
            <span v-if="param.for_currency">Moeda: {{param.for_currency}}&nbsp;</span>
            Debitada {{booleanToString(param.debited)}}
          </v-chip>
        </Draggable>
      </Container>
    </v-flex>
    <v-layout row v-if="mode != 'read'">
      <v-flex xs4 md2 pr-1>
        <v-checkbox
          v-model="debited"
          label="Debited">
        </v-checkbox>
      </v-flex>
      <v-flex xs6 md2 pr-1 @keyup.up="fixed_value += 0.1" @keyup.down="fixed_value -= 0.1">
        <v-currency-field
          label="Valor fixo"
          v-bind="currency_config"
          v-model="fixed_value">
        </v-currency-field>
      </v-flex>
      <v-flex xs6 md2 pr-1 @keyup.up="percentage_value += 0.1" @keyup.down="percentage_value -= 0.1">
        <v-currency-field
          label="Valor percentual"
          v-bind="currency_config"
          v-model="percentage_value">
        </v-currency-field>
      </v-flex>
      <v-flex xs6 md2 pr-1 @keyup.up="greater_than += 1000" @keyup.down="greater_than -= 1000">
        <v-currency-field
          label="Acima de"
          v-bind="currency_config"
          v-model="greater_than">
        </v-currency-field>
      </v-flex>
      <v-flex xs6 md2 pr-1>
        <v-text-field
          label="Para moeda"
          v-model="for_currency">
        </v-text-field>
      </v-flex>
      <v-flex xs6 md4 pr-1>
        <v-text-field
          label="Para conta"
          v-model="for_bank_account_id">
        </v-text-field>
      </v-flex>
      <v-btn v-if="mode == 'insert'"  @click="addToRuleset">Inserir</v-btn>
      <v-btn v-if="mode == 'edit'" color="primary" @click="saveRule">Salvar</v-btn>
    </v-layout>
  </div>
</template>

<script>
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag } from "../shared/DndropUtils";
export default {
  name: 'TaxItem',
  components: { Container, Draggable },
  props: {
    tax_name: {
      type: String,
      default: ''
    },
    tax_ruleset: {
      type: Array,
      default: []
    },
    currentItem: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currency_config: {
        decimal: ',',
        thousands: '.',
        precision: 2
      },
      debited: false,
      fixed_value: '0.00',
      percentage_value: '0.00',
      greater_than: '0.00',
      for_currency: '',
      for_bank_account_id: '',
      currentEditIndex: null,
      mode: 'read',
      fee_names_translations: {
        boleto_tax: 'Boleto',
        receive_credit_card_tax: 'Cartão de Crédito',
        iof_rate: 'IOF Cash-in',
        sell_iof_rate: 'IOF Cash-out',
        chargeback_tax: 'Chargeback',
        sent_pix_tax: 'Pix Enviado',
        receive_pix_tax: 'Pix Recebido',
        sent_ted_tax: 'TED Enviado',
        receive_ted_tax: 'TED Recebido',
        refund_tax: 'Reembolso',
        sent_spei_tax: 'SPEI Enviado',
        receive_spei_tax: 'SPEI Recebido',
        sent_wire_tax: 'Wire Enviado',
        receive_wire_tax: 'Wire Recebido',
        oxxo_tax: 'Oxxo',
        pse_tax: 'PSE Recebido',
        sent_pse_tax: 'PSE Enviado'
      }
    }
  },
  methods: {
    onDrop(dropResult) {
      this.tax_ruleset = applyDrag(this.tax_ruleset, dropResult);
      this.$emit('updateRules', [this.tax_ruleset, this.tax_name])
    },
    addToRuleset() {
      this.tax_ruleset.push(this.getRuleFormValues())
      this.$emit('updateRules', [this.tax_ruleset, this.tax_name])
      this.clearFields()
    },
    clearFields() {
      this.fixed_value = '0.00'
      this.percentage_value = '0.00'
      this.greater_than = '0.00'
      this.for_currency = ''
      this.for_bank_account_id = ''
      this.mode = 'read'
    },
    translateToFeeName(value) {
      return this.fee_names_translations[value] || value
    },
    editRule(fee, index) {
      this.mode = 'edit'
      this.currentEditIndex = index
      this.fixed_value = this.toFixedOrDefault(fee.fixed_value, '0.00')
      this.percentage_value = this.toFixedOrDefault(fee.percentage_value, '0.00')
      this.greater_than = this.toFixedOrDefault(fee.greater_than, '0.00')
      this.for_currency = fee.for_currency
      this.for_bank_account_id = fee.for_bank_account_id
      this.debited = fee.debited
    },
    toFixedOrDefault(value, defaultValue) {
      return value && Number(value).toFixed(2) || defaultValue
    },
    booleanToString(value) {
      if (value === true) return "Sim"
      return "Não"
    },
    saveRule() {
      this.tax_ruleset[this.currentEditIndex] = this.getRuleFormValues()
      this.$emit('updateRules', [this.tax_ruleset, this.tax_name])
      this.clearFields()
    },
    getRuleFormValues() {
      let rule_info = {
        fixed_value: this.fixed_value.toFixed(2),
        percentage_value: this.percentage_value.toFixed(2),
        debited: this.debited
      }

      if(this.greater_than && this.greater_than.toFixed(2) !== '0.00') {
        rule_info.greater_than = this.greater_than.toFixed(2)
      }

      if(this.for_currency && this.for_currency.trim()) {
        rule_info.for_currency = this.for_currency.trim()
      }

      if(this.for_bank_account_id && this.for_bank_account_id.trim()) {
        rule_info.for_bank_account_id = this.for_bank_account_id.trim()
      }

      return rule_info
    },
    removeRule() {
      this.tax_ruleset = this.tax_ruleset.splice(0, 1)
    }
  }
}
</script>

<style>
  .tax-card{
    display: block;
    align-items: center;
    border: 1px solid rgba(89, 123, 160, .667);
    border-left: 5px solid #42b883;
    border-radius: 4px;
    padding: 0.5rem 1rem;
    margin: 5px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/TaxItem.vue